class VideoClass {
    constructor(modalId) {
        this.elems = {
            modalId,
            ytPlayerId: null,
            ytVideo: null
        };
    }

    onYouTubeIframeAPIReady() {
        // Add new player object to ytVideos object
        this.elems.ytVideo = new YT.Player('player', {// eslint-disable-line no-undef
            height: '390',
            width: '640',
            videoId: this.elems.modalId,
            events: {
                onReady: this.onPlayerReady
            },
            playerVars: {
                rel: 0
            }
        });
    }

    onPlayerReady(event) {
        // Autoplay video when player is ready
        event.target.playVideo();
    }

    openModal() {
        // Open modal and set target player ID
        this.elems.ytPlayerId = this.elems.modalId;

        if (this.elems.ytVideo) {
            // If  target player already exists, autoplay
            this.elems.ytVideo.playVideo();
        } else {
            // If target player does not exist, create new player
            this.onYouTubeIframeAPIReady();
        }
    }

    closeModal() {
        // Stop target video when modal is closed
        this.elems.ytVideo.stopVideo();
    }
}

export default VideoClass;
